import { Box, Container, VStack, Heading, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import RotaryLogo from './RotaryLogo';
import ProductName from './ProductName';

const VerificationPending = () => {
  const navigate = useNavigate();

  return (
    <Container maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
      <VStack spacing="8">
        <RotaryLogo width="100px" height="100px" />
        <ProductName />
        <Box textAlign="center">
          <Heading size="lg" mb={4}>Verify Your Email</Heading>
          <Text mb={4}>
            We've sent you a verification email. Please check your inbox and click the verification link to complete your registration.
          </Text>
          <Text mb={6} fontSize="sm" color="gray.600">
            If you don't see the email, please check your spam folder.
          </Text>
          <Button
            colorScheme="blue"
            onClick={() => navigate('/login')}
          >
            Return to Login
          </Button>
        </Box>
      </VStack>
    </Container>
  );
};

export default VerificationPending;
